// src/utils/useTilt.ts
// Hafif, WebGL kullanmadan CSS 3D transform ile "tilt" (fareyle eğilme) efekti.
// Kartların üstünde fare hareket ettikçe hafif bir 3D derinlik hissi verir.
import { useState, useCallback } from "react";

export interface TiltState {
  rotateX: number;
  rotateY: number;
}

const DEFAULT_TILT: TiltState = { rotateX: 0, rotateY: 0 };

export function useTilt(maxTilt: number = 8) {
  const [tilt, setTilt] = useState<TiltState>(DEFAULT_TILT);

  const onMouseMove = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      const rect = e.currentTarget.getBoundingClientRect();
      const px = (e.clientX - rect.left) / rect.width; // 0..1
      const py = (e.clientY - rect.top) / rect.height; // 0..1
      setTilt({
        rotateX: (py - 0.5) * -maxTilt,
        rotateY: (px - 0.5) * maxTilt,
      });
    },
    [maxTilt]
  );

  const onMouseLeave = useCallback(() => setTilt(DEFAULT_TILT), []);

  return { tilt, onMouseMove, onMouseLeave };
}
